import { useEffect } from "react";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogType?: string;
  ogImage?: string;
  twitterCard?: string;
  schemaObjects?: Record<string, unknown>[];
}

export function useSEO(props: SEOProps) {
  useEffect(() => {
    document.title = props.title;

    const setMeta = (name: string, content: string, attrName = "name") => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", props.description);
    if (props.keywords) setMeta("keywords", props.keywords);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (props.canonicalUrl) {
      if (canonical) canonical.setAttribute("href", props.canonicalUrl);
      else {
        const link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        link.setAttribute("href", props.canonicalUrl);
        document.head.appendChild(link);
      }
    }

    if (props.ogTitle) setMeta("og:title", props.ogTitle, "property");
    if (props.ogDescription) setMeta("og:description", props.ogDescription, "property");
    if (props.ogUrl) setMeta("og:url", props.ogUrl, "property");
    if (props.ogType) setMeta("og:type", props.ogType, "property");
    if (props.ogImage) setMeta("og:image", props.ogImage, "property");

    if (props.twitterCard) setMeta("twitter:card", props.twitterCard, "name");
    if (props.ogTitle) setMeta("twitter:title", props.ogTitle, "name");
    if (props.ogDescription) setMeta("twitter:description", props.ogDescription, "name");

    const existingScripts = document.querySelectorAll('script[data-seo-schema]');
    existingScripts.forEach((s) => s.remove());

    if (props.schemaObjects) {
      props.schemaObjects.forEach((schema) => {
        const script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        script.setAttribute("data-seo-schema", "true");
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
      });
    }
  }, [props]);
}